import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ModalCloseButton } from './';

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
  z-index: 10000;
  overflow-y: scroll;
`;

const ModalContent = props => {
  const { children, onClose } = props;
  return (
    <ModalContainer>
      {onClose && <ModalCloseButton onClick={onClose} />}
      {children}
    </ModalContainer>
  );
};

ModalContent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
  onClose: PropTypes.func,
};

export default ModalContent;



// WEBPACK FOOTER //
// ./src/modules/pages/components/ModalContent.js